import { render, staticRenderFns } from "./DilekceForm.vue?vue&type=template&id=53d3da1c"
import script from "./DilekceForm.vue?vue&type=script&lang=ts"
export * from "./DilekceForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports